import moment, { Moment } from "moment";

moment.locale("de", { week: { dow: 1 } });

export const getXDateTicks = (
  chartData: Array<{ x: string } & Record<string, unknown>>
): string[] => {
  const xDates = chartData.reduce<Date[]>((xTickArray, datapoint) => {
    const date = new Date(datapoint.x);
    if (
      xTickArray.length == 0 ||
      date.getMonth() > xTickArray[xTickArray.length - 1].getMonth() ||
      date.getFullYear() > xTickArray[xTickArray.length - 1].getFullYear()
    ) {
      return xTickArray.concat([date]);
    } else {
      return xTickArray;
    }
  }, []);
  return xDates.map((date) => date.toISOString());
};

export const xTickFunction = (xTicks: string[], xValue: string) => {
  if (xTicks.includes(xValue)) {
    return moment(xValue).format("MM/YYYY");
  } else {
    return "";
  }
};

export const getLastWeek = () => {
  const now = moment();
  const dateLastWeek = now.clone().subtract(1, "week");
  const lastWeek = dateLastWeek.isoWeek();
  const yearLastWeek = dateLastWeek.isoWeekYear();
  const weekRangeString = getWeekRangeStringForDate(dateLastWeek);
  return { lastWeek, yearLastWeek, weekRangeString };
};

export const getWeekRangeStringForDate = (date: string | Moment) => {
  const d = typeof date === "string" ? moment(date) : date;
  const weekStart = d.clone().startOf("week").format("DD.MM.YYYY");
  const weekEnd = d.clone().endOf("week").format("DD.MM.YYYY");
  const weekRangeString = `${weekStart} - ${weekEnd}`;
  return weekRangeString;
};



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/helpers.ts